import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';

const _DeleteNoteByIdRequestDtoSchema = z.object({
  id: z.number(),
  noteId: z.number(),
});

export type DeleteNoteByIdRequestDto = z.infer<
  typeof _DeleteNoteByIdRequestDtoSchema
>;

export const deleteNote = async (
  params: DeleteNoteByIdRequestDto,
  config?: AxiosRequestConfig<DeleteNoteByIdRequestDto>
) => {
  const { id, noteId } = params;

  return await api.delete(`staff/${id}/notes/${noteId}`, config);
};
